// 左侧菜单New标签id配置
export const MENUS_NEW_MARKS_MAPPING: {
  [key: string]: string;
} = {
  /** Following一级菜单，预留范围1-20 **/
  Following: 'menu00001',
  /** Following一级菜单，预留范围1-20 **/

  /** TopCharts一级菜单，预留范围21-40 **/
  TopChartsMobileGames: 'menu00021',
  TopChartsPCGames: 'menu00022',
  TopChartsConsoleGames: 'menu00023',
  // TopChartsPCConsoleGames: 'menu00024',
  TopChartsCompanies: 'menu00025',
  // TopChartsPCConsoleGames: 'menu00026',
  TopChartsPCConsoleGames: 'menu00027',
  /** TopCharts一级菜单，预留范围21-40 **/

  IPLibrary: 'menu00028',
  /** TopCharts一级菜单，预留范围21-40 **/

  /** StoreRanks一级菜单，预留范围41-60 **/
  'StoreRanksMobile Global/Region': 'menu00041',
  StoreRanksPCGlobal: 'menu00042',
  StoreRanksConsoleRegion: 'menu00043',
  /** StoreRanks一级菜单，预留范围41-60 **/

  /** MarketProfile一级菜单，预留范围61-80 **/
  MarketProfile: 'menu00061',
  /** MarketProfile一级菜单，预留范围61-80 **/

  /** GenreProfile一级菜单，预留范围81-100 **/
  GenreProfile: 'menu00081',
  /** GenreProfile一级菜单，预留范围81-100 **/

  /** GlobalView一级菜单，预留范围101-120 **/
  GlobalViewMarketSize: 'menu00101',
  GlobalViewTopGenrePerMarket: 'menu00102',
  GlobalViewTopMarketPerGenre: 'menu00103',
  /** GlobalView一级菜单，预留范围101-120 **/

  /** Reports一级菜单，预留范围121-140 **/
  ReportsTrendingGames: 'menu00121',
  ReportsMarketReports: 'menu00122',
  ReportsInsightsReports: 'menu00123',
  ReportsIMurReports: 'menu00124',
  ReportsGameAnalysisReports: 'menu00125',
  ReportsInsightsCenterLibrary: 'menu00126',
  /** Reports一级菜单，预留范围121-140 **/

  /** Benchmark一级菜单，预留范围141-160 **/
  BenchmarkMobileGameBenchmark: 'menu00141',
  BenchmarkPCConsoleBenchmark: 'menu00142',
  /** Benchmark一级菜单，预留范围141-160 **/

  /** Overlap Analysis一级菜单，预留范围161-180 **/
  OverlapAnalysisMobileGames: 'menu00161',
  OverlapAnalysisSteamGames: 'menu00162',
  /** Overlap Analysis一级菜单，预留范围161-180 **/

  /** Compare一级菜单，预留范围181-200 **/
  CompareMobileGames: 'menu00181',
  ComparePCConsoleGames: 'menu00182',
  /** Compare一级菜单，预留范围181-200 **/

  /** Streaming一级菜单，预留范围201-220 **/
  StreamingInfluencer: 'menu00201',
  StreamingGames: 'menu00202',
  /** Streaming一级菜单，预留范围201-220 **/

  /** Potential一级菜单，预留范围221-240 **/
  PotentialNewReleaseGames: 'menu00221',
  PotentialUpcomingGames: 'menu00222',
  PotentialSteamMetrics: 'menu00223',
  /** Potential一级菜单，预留范围221-240 **/

  /** Mobile Device一级菜单，预留范围241-260 **/
  MobileDeviceGlobalOverview: 'menu00241',
  MobileDeviceStats: 'menu00242',
  MobileDeviceReports: 'menu00243',
  /** Mobile Device一级菜单，预留范围241-260 **/

  /** Sources & Metrics一级菜单，预留范围261-280 **/
  'Sources&MetricsOverview': 'menu00261',
  'Sources&MetricsSources': 'menu00262',
  'Sources&MetricsMetrics': 'menu00263',
  /** Sources & Metrics一级菜单，预留范围261-280 **/
};

// tab页签New标签id配置
export const TABS_NEW_MARKS_MAPPING: {
  [key: string]: string;
} = {
  // 榜单页

  /** TopCharts_MobileGames榜单页签，预留范围1-20 **/
  TopChartsMobileGamesActiveUsers: 'tab00001',
  TopChartsMobileGamesRevenue: 'tab00002',
  TopChartsMobileGamesDownloads: 'tab00003',
  TopChartsMobileGamesRPD: 'tab00004',
  TopChartsMobileGamesRetention: 'tab00005',
  TopChartsMobileGamesDemographics: 'tab00006',
  TopChartsMobileGamesNewRelease: 'tab00007',
  TopChartsMobileGamesUpcoming: 'tab00008',
  TopChartsMobileGamesDataBrainCalibration: 'tab00009',
  /** TopCharts_MobileGames榜单页签，预留范围1-20 **/

  /** TopCharts_PCGames榜单页签，预留范围21-40 **/
  TopChartsPCGamesMetricsTable: 'tab00021',
  TopChartsPCGamesPCU: 'tab00022',
  TopChartsPCGamesDigitalRevenue: 'tab00023',
  TopChartsPCGamesPhysicalRevenue: 'tab00024',
  TopChartsPCGamesSteamSales: 'tab00025',
  TopChartsPCGamesMAU: 'tab00026',
  TopChartsPCGamesLifetimePlayers: 'tab00027',
  TopChartsPCGamesNewRelease: 'tab00028',
  TopChartsPCGamesUpcoming: 'tab00029',
  /** TopCharts_PCGames榜单页签，预留范围21-40 **/

  /** TopCharts_ConsoleGames榜单页签，预留范围41-60 **/
  TopChartsConsoleGamesMetricsTable: 'tab00041',
  TopChartsConsoleGamesDigitalRevenue: 'tab00042',
  TopChartsConsoleGamesPhysicalRevenue: 'tab00043',
  TopChartsConsoleGamesJapanSales: 'tab00044',
  TopChartsConsoleGamesMAU: 'tab00045',
  TopChartsConsoleGamesLifetimePlayers: 'tab00046',
  TopChartsConsoleGamesNewRelease: 'tab00047',
  TopChartsConsoleGamesUpcoming: 'tab00048',
  /** TopCharts_ConsoleGames榜单页签，预留范围41-60 **/

  /** TopCharts_PCConsoleGames榜单页签，预留范围60-80 **/
  TopChartsPCConsoleGamesMetricsTable: 'tab00060',
  TopChartsPCConsoleGamesDataBrainCalibration: 'tab00061',
  /** TopCharts_ConsoleGames榜单页签，预留范围60-80 **/

  // 61-80 预留给TopCharts_PCConsole榜单（目前只有一个页面 不存在页签形式，可能后续会扩充页面，就会出现页签了）

  /** TopCharts_Companies榜单页签，预留范围81-100 **/
  TopChartsCompaniesRevenue: 'tab00081',
  TopChartsCompaniesDownloads: 'tab00082',
  TopChartsCompaniesMentions: 'tab00083',
  /** TopCharts_Companies榜单页签，预留范围81-100 **/

  /** StoreRanks_MobileGlobal/Region页签，预留范围101-120 **/
  'StoreRanksMobileGlobal/RegionAllTopCharts': 'tab00101',
  'StoreRanksMobileGlobal/RegionGlobalCompare': 'tab00102',
  /** StoreRanks_MobileGlobal/Region页签，预留范围101-120 **/

  /** StoreRanks_PCGlobal页签，预留范围121-140 **/
  StoreRanksPCGlobalSteam: 'tab00121',
  StoreRanksPCGlobalEpicGames: 'tab00122',
  /** StoreRanks_PCGlobal页签，预留范围121-140 **/

  /** StoreRanks_ConsoleRegion页签，预留范围141-160 **/
  StoreRanksConsoleRegionPlaystation: 'tab00141',
  StoreRanksConsoleRegionXbox: 'tab00142',
  StoreRanksConsoleRegionNintendo: 'tab00143',
  /** StoreRanks_ConsoleRegion页签，预留范围141-160 **/

  /** MarketProfile页签，预留范围161-180 **/
  MarketProfileMobileGames: 'tab00161',
  MarketProfilePCConsoleGames: 'tab00165',
  MarketProfilePCGames: 'tab00162',
  MarketProfileConsoleGames: 'tab00163',
  MarketProfileAnnualReport: 'tab00164',
  /** MarketProfile页签，预留范围161-180 **/

  /** GenreProfile页签，预留范围181-200 **/
  GenreProfileMobileGames: 'tab00181',
  GenreProfilePCGames: 'tab00182',
  GenreProfileConsoleGames: 'tab00183',
  GenreProfileTotalGames: 'tab00184',
  /** GenreProfile页签，预留范围181-200 **/

  /** GlobalView_MarketSize页签，预留范围201-220 **/
  GlobalViewMarketSizeByRevenue: 'tab00201',
  GlobalViewMarketSizeByPlayers: 'tab00202',
  /** GlobalView_MarketSize页签，预留范围201-220 **/

  /** GlobalView_TopGenrePerMarket页签，预留范围221-240 **/
  GlobalViewTopGenrePerMarketTotalMarket: 'tab00221',
  GlobalViewTopGenrePerMarketMobileGames: 'tab00222',
  GlobalViewTopGenrePerMarketPCGames: 'tab00223',
  GlobalViewTopGenrePerMarketConsoleGames: 'tab00224',
  /** GlobalView_TopGenrePerMarket页签，预留范围221-240 **/

  /** GlobalView_TopMarketPerGenre页签，预留范围241-260 **/
  GlobalViewTopMarketPerGenreTotalMarket: 'tab00241',
  GlobalViewTopMarketPerGenreMobileGames: 'tab00242',
  GlobalViewTopMarketPerGenrePCGames: 'tab00243',
  GlobalViewTopMarketPerGenreConsoleGames: 'tab00244',
  /** GlobalView_TopMarketPerGenre页签，预留范围241-260 **/

  // 261-280 预留给Reports_TrendingGames页签（目前只有一个页面 不存在页签形式，可能后续会扩充页面，就会出现页签了）

  /** Reports_MarketReports页签，预留范围281-300 **/
  ReportsMarketReportsNewzoo: 'tab00281',
  ReportsMarketReportsStatista: 'tab00282',
  ReportsMarketReportsSensorTower: 'tab00283',
  ReportsMarketReportsDataAi: 'tab00284',
  ReportsMarketReportsStreamHatchet: 'tab00285',
  ReportsMarketReportsNPD: 'tab00286',
  ReportsMarketReportsFamitsu: 'tab00287',
  ReportsMarketReportsTwitter: 'tab00288',
  ReportsMarketReportsFandom: 'tab00289',
  /** Reports_MarketReports页签，预留范围281-300 **/

  /** Reports_InsightsReports页签，预留范围301-310 **/
  ReportsInsightsReportsAll: 'tab00301',
  ReportsInsightsReportsGeneralGaming: 'tab00302',
  ReportsInsightsReportsEsports: 'tab00303',
  /** Reports_InsightsReports页签，预留范围301-310 **/

  /** Reports_InsightsCenterLibrary 页签，预留范围311-320 **/
  ReportsInsightsCenterLibraryAll: 'tab00311',
  ReportsInsightsCenterLibraryFundamentalStudy: 'tab00312',
  ReportsInsightsCenterLibraryGRIP: 'tab00313',
  ReportsInsightsCenterLibraryAdHocResearch: 'tab00314',
  ReportsInsightsCenterLibraryRegionalMonthlyReport: 'tab00315',
  /** Reports_InsightsCenterLibrary 页签，预留范围311-320 **/

  /** Reports_IMurReports页签，预留范围321-340 **/
  ReportsIMurReportsAll: 'tab00321',
  ReportsIMurReportsWhitePapers: 'tab00322',
  ReportsIMurReportsMonitoringReports: 'tab00323',
  'ReportsIMurReportsGenres&Competitors': 'tab00324',
  'ReportsIMurReportsOperation&Publishing': 'tab00325',
  ReportsIMurReportsSpecificReports: 'tab00326',
  ReportsIMurReportsGameCompanies: 'tab00327',
  ReportsIMurReportsNewTech: 'tab00328',
  /** Reports_IMurReports页签，预留范围321-340 **/

  /** Compare_MobileGames页签，预留范围341-360 **/
  CompareMobileGamesActiveUsers: 'tab00341',
  CompareMobileGamesRevenue: 'tab00342',
  CompareMobileGamesDownloads: 'tab00343',
  CompareMobileGamesStoreRank: 'tab00344',
  /** Compare_MobileGames页签，预留范围341-360 **/

  /** Compare_PC&ConsoleGames页签，预留范围361-380 **/
  ComparePCConsoleGamesPCU: 'tab00361',
  ComparePCConsoleGamesMAU: 'tab00362',
  ComparePCConsoleGamesDigitalRevenue: 'tab00363',
  ComparePCConsoleGamesPhysicalRevenue: 'tab00364',
  /** Compare_PC&ConsoleGames页签，预留范围361-380 **/

  /** Potential_NewReleaseGames页签，预留范围381-400 **/
  PotentialNewReleaseGamesMobileGames: 'tab00381',
  PotentialNewReleaseGamesPCGames: 'tab00382',
  PotentialNewReleaseGamesConsoleGames: 'tab00383',
  /** Potential_NewReleaseGames页签，预留范围381-400 **/

  /** Potential_UpcomingGames页签，预留范围401-420 **/
  PotentialUpcomingGamesMobileGames: 'tab00401',
  PotentialUpcomingGamesPCGames: 'tab00402',
  PotentialUpcomingGamesConsoleGames: 'tab00403',
  /** Potential_UpcomingGames页签，预留范围401-420 **/

  /** Source&Metrics_Sources页签，预留范围421-440 **/
  'Sources&MetricsSourcesIntelligenceSources': 'tab00421',
  'Sources&MetricsSourcesOpinionsSources': 'tab00422',
  'Sources&MetricsSourcesNewsCrawlers': 'tab00423',
  /** Source&Metrics_Sources页签，预留范围421-440 **/

  /** Source&Metrics_Metrics页签，预留范围441-460 **/
  'Sources&MetricsMetricsIntelligenceMetrics': 'tab00441',
  'Sources&MetricsMetricsOpinionsMetrics': 'tab00442',
  'Sources&MetricsMetricsMobileGameFields': 'tab00443',
  'Sources&MetricsMetricsPCConsoleGameFields': 'tab00444',
  'Sources&MetricsMetricsCompanyFields': 'tab00445',
  'Sources&MetricsMetricsDeviceMetrics': 'tab00446',
  /** Source&Metrics_Metrics页签，预留范围441-460 **/

  // 详情页

  /** MobileGames详情页页签，预留范围461-480 **/
  MobileGamesDetailsOverview: 'tab00461',
  MobileGamesDetailsStats: 'tab00462',
  MobileGamesDetailsCountries: 'tab00463',
  MobileGamesDetailsStoreRank: 'tab00464',
  MobileGamesDetailsStreaming: 'tab00465',
  MobileGamesDetailsDemographics: 'tab00466',
  MobileGamesDetailsOverlap: 'tab00467',
  MobileGamesDetailsOpinions: 'tab00468',
  MobileGamesDetailsGameComparison: 'tab00469',
  /** MobileGames详情页页签，预留范围461-480 **/

  /** PCGames详情页页签，预留范围481-500 **/
  PCGamesDetailsOverview: 'tab00481',
  PCGamesDetailsStats: 'tab00482',
  PCGamesDetailsCountries: 'tab00483',
  PCGamesDetailsStoreRank: 'tab00484',
  PCGamesDetailsStreaming: 'tab00485',
  PCGamesDetailsOpinions: 'tab00486',

  PCGamesDetailsOverlap: 'tab00487',
  PCGamesDetailsGameComparison: 'tab00488',

  /** PCGames详情页页签，预留范围481-500 **/

  /** ConsoleGames详情页页签，预留范围501-520 **/
  ConsoleGamesDetailsOverview: 'tab00501',
  ConsoleGamesDetailsStats: 'tab00502',
  ConsoleGamesDetailsCountries: 'tab00503',
  ConsoleGamesDetailsStoreRank: 'tab00504',
  ConsoleGamesDetailsStreaming: 'tab00505',
  ConsoleGamesDetailsOpinions: 'tab00506',
  ConsoleGamesDetailsGameComparison: 'tab00507',
  /** ConsoleGames详情页页签，预留范围501-520 **/

  /** PCConsoleGames详情页页签，预留范围521-540 **/
  PCConsoleGamesDetailsOverview: 'tab00521',
  PCConsoleGamesDetailsStats: 'tab00522',
  // PCConsoleGamesDetailsCountries: 'tab00523',
  PCConsoleGamesDetailsStoreRank: 'tab00524',
  PCConsoleGamesDetailsStreaming: 'tab00525',
  PCConsoleGamesDetailsOpinions: 'tab00526',

  PCConsoleGamesDetailsOverlap: 'tab00527',
  PCConsoleGamesDetailsGameInfo: 'tab00528',
  PCConsoleGamesDetailsKPITrends: 'tab00529',

  // 暂时使用新 id ，避免原有 id 被点击后 id 被存储再后端的排除项中
  PCConsoleGamesDetailsCountries: 'tab00530',
  PCConsoleGamesDetailsGameComparison: 'tab00531',
  /** PCConsoleGames详情页页签，预留范围521-540 **/

  /** Companies详情页页签，预留范围541-560 **/
  CompaniesDetailsSummary: 'tab00541',
  'CompaniesDetailsNews&Activity': 'tab00542',
  'CompaniesDetailsGames&Stats': 'tab00543',
  CompaniesDetailsFinancials: 'tab00544',
  CompaniesDetailsSubsidiaryCompanies: 'tab00545',
  CompaniesDetailsPeople: 'tab00546',
  CompaniesDetailsSimilarCompanies: 'tab00547',
  /** Companies详情页页签，预留范围541-560 **/

  /** MarketProfile详情页页签，预留范围561-580 **/
  MarketProfileDetailsOverview: 'tab00561',
  MarketProfileDetailsInsights: 'tab00562',
  MarketProfileDetailsStats: 'tab00563',
  MarketProfileDetailsDemographics: 'tab00564',
  /** MarketProfile详情页页签，预留范围561-580 **/

  /** GenreProfile详情页页签，预留范围581-600 **/
  GenreProfileDetailsInsights: 'tab00581',
  GenreProfileDetailsStats: 'tab00582',
  /** GenreProfile详情页页签，预留范围581-600 **/

  /** GenreProfile详情页页签，预留范围581-600 **/

  /** IP Library页签，预留范围601-620 **/
  IPLibraryGameIPClassicalIP: 'tab601',
  /** IP Library页签，预留范围601-620 **/
};

// 左侧菜单id与菜单对应的newMarkId的映射关系（因为左侧菜单id有存在数据库，所以id不能改，为了让左侧菜单的newMarkId跟tab的newMarkId格式保持一致，所以加了这个映射）
// 注意 之类menu的id是下划线连接的数字，这里的key一定要用引号，否则打包后 会自动去掉下划线 变成纯数字
export const MENUS_NEW_MARK_IDS_MAPPING: {
  [key: string]: string;
} = {
  '1001': MENUS_NEW_MARKS_MAPPING.Following,
  '1002_1': MENUS_NEW_MARKS_MAPPING.TopChartsMobileGames,
  '1002_2': MENUS_NEW_MARKS_MAPPING.TopChartsPCGames,
  '1002_3': MENUS_NEW_MARKS_MAPPING.TopChartsConsoleGames,
  '1002_4': MENUS_NEW_MARKS_MAPPING.TopChartsPCConsoleGames,
  '1016': MENUS_NEW_MARKS_MAPPING.IPLibrary,
  '1002_5': MENUS_NEW_MARKS_MAPPING.TopChartsCompanies,
  '1003_1': MENUS_NEW_MARKS_MAPPING['StoreRanksMobile Global/Region'],
  '1003_2': MENUS_NEW_MARKS_MAPPING.StoreRanksPCGlobal,
  '1003_3': MENUS_NEW_MARKS_MAPPING.StoreRanksConsoleRegion,
  '1004': MENUS_NEW_MARKS_MAPPING.MarketProfile,
  '1005': MENUS_NEW_MARKS_MAPPING.GenreProfile,
  '1006_1': MENUS_NEW_MARKS_MAPPING.GlobalViewMarketSize,
  '1006_2': MENUS_NEW_MARKS_MAPPING.GlobalViewTopGenrePerMarket,
  '1006_3': MENUS_NEW_MARKS_MAPPING.GlobalViewTopMarketPerGenre,
  '1007_1': MENUS_NEW_MARKS_MAPPING.ReportsTrendingGames,
  '1007_2': MENUS_NEW_MARKS_MAPPING.ReportsMarketReports,
  '1007_3': MENUS_NEW_MARKS_MAPPING.ReportsInsightsReports,
  '1007_4': MENUS_NEW_MARKS_MAPPING.ReportsIMurReports,
  '1007_5': MENUS_NEW_MARKS_MAPPING.ReportsGameAnalysisReports,
  '1007_6': MENUS_NEW_MARKS_MAPPING.ReportsInsightsCenterLibrary,
  '1008_1': MENUS_NEW_MARKS_MAPPING.BenchmarkMobileGameBenchmark,
  '1008_2': MENUS_NEW_MARKS_MAPPING.BenchmarkPCConsoleBenchmark,
  '1014_1': MENUS_NEW_MARKS_MAPPING.OverlapAnalysisMobileGames,
  '1014_2': MENUS_NEW_MARKS_MAPPING.OverlapAnalysisSteamGames,
  '1009_1': MENUS_NEW_MARKS_MAPPING.CompareMobileGames,
  '1009_2': MENUS_NEW_MARKS_MAPPING.ComparePCConsoleGames,
  '1010_1': MENUS_NEW_MARKS_MAPPING.StreamingInfluencer,
  '1010_2': MENUS_NEW_MARKS_MAPPING.StreamingGames,
  '1011_1': MENUS_NEW_MARKS_MAPPING.PotentialNewReleaseGames,
  '1011_2': MENUS_NEW_MARKS_MAPPING.PotentialUpcomingGames,
  '1011_3': MENUS_NEW_MARKS_MAPPING.PotentialSteamMetrics,
  '1012_1': MENUS_NEW_MARKS_MAPPING.MobileDeviceGlobalOverview,
  '1012_2': MENUS_NEW_MARKS_MAPPING.MobileDeviceStats,
  '1012_3': MENUS_NEW_MARKS_MAPPING.MobileDeviceReports,
  '1013_1': MENUS_NEW_MARKS_MAPPING['Sources&MetricsOverview'],
  '1013_2': MENUS_NEW_MARKS_MAPPING['Sources&MetricsSources'],
  '1013_3': MENUS_NEW_MARKS_MAPPING['Sources&MetricsMetrics'],
};

// tab的id与tab对应的newMarkId的映射关系（因为整个系统里tab的id有重复的，所以需要映射为整个系统唯一的newMarkID）
export const TABS_NEW_MARK_IDS_MAPPING: {
  [key: string]: {
    [key: string]: string;
  };
} = {
  // TopCharts_MobileGames页签的tab的newMarkId映射表
  TopChartsMobileGames: {
    ActiveUsers: TABS_NEW_MARKS_MAPPING.TopChartsMobileGamesActiveUsers,
    Revenue: TABS_NEW_MARKS_MAPPING.TopChartsMobileGamesRevenue,
    Downloads: TABS_NEW_MARKS_MAPPING.TopChartsMobileGamesDownloads,
    RPD: TABS_NEW_MARKS_MAPPING.TopChartsMobileGamesRPD,
    Retention: TABS_NEW_MARKS_MAPPING.TopChartsMobileGamesRetention,
    Demographics: TABS_NEW_MARKS_MAPPING.TopChartsMobileGamesDemographics,
    NewRelease: TABS_NEW_MARKS_MAPPING.TopChartsMobileGamesNewRelease,
    Upcoming: TABS_NEW_MARKS_MAPPING.TopChartsMobileGamesUpcoming,
    DataBrainCalibration: TABS_NEW_MARKS_MAPPING.TopChartsMobileGamesDataBrainCalibration,
  },
  // TopCharts_PCGames页签的tab的newMarkId映射表
  TopChartsPCGames: {
    MetricsTable: TABS_NEW_MARKS_MAPPING.TopChartsPCGamesMetricsTable,
    PCU: TABS_NEW_MARKS_MAPPING.TopChartsPCGamesPCU,
    DigitalRevenue: TABS_NEW_MARKS_MAPPING.TopChartsPCGamesDigitalRevenue,
    PhysicalRevenue: TABS_NEW_MARKS_MAPPING.TopChartsPCGamesPhysicalRevenue,
    SteamSales: TABS_NEW_MARKS_MAPPING.TopChartsPCGamesSteamSales,
    MAU: TABS_NEW_MARKS_MAPPING.TopChartsPCGamesMAU,
    LifeTimePlayers: TABS_NEW_MARKS_MAPPING.TopChartsPCGamesLifetimePlayers,
    NewRelease: TABS_NEW_MARKS_MAPPING.TopChartsPCGamesNewRelease,
    Upcoming: TABS_NEW_MARKS_MAPPING.TopChartsPCGamesUpcoming,
  },
  // TopCharts_ConsoleGames页签的tab的newMarkId映射表
  TopChartsConsoleGames: {
    MetricsTable: TABS_NEW_MARKS_MAPPING.TopChartsConsoleGamesMetricsTable,
    DigitalRevenue: TABS_NEW_MARKS_MAPPING.TopChartsConsoleGamesDigitalRevenue,
    PhysicalRevenue: TABS_NEW_MARKS_MAPPING.TopChartsConsoleGamesPhysicalRevenue,
    JapanSales: TABS_NEW_MARKS_MAPPING.TopChartsConsoleGamesJapanSales,
    MAU: TABS_NEW_MARKS_MAPPING.TopChartsConsoleGamesMAU,
    LifeTimePlayers: TABS_NEW_MARKS_MAPPING.TopChartsConsoleGamesLifetimePlayers,
    NewRelease: TABS_NEW_MARKS_MAPPING.TopChartsConsoleGamesNewRelease,
    Upcoming: TABS_NEW_MARKS_MAPPING.TopChartsConsoleGamesUpcoming,
  },
  // TopCharts_PCConsoleGames页签的tab的newMarkId映射表
  TopChartsPCConsoleGames: {
    MetricsTable: TABS_NEW_MARKS_MAPPING.TopChartsPCConsoleGamesMetricsTable,
    DataBrainCalibration: TABS_NEW_MARKS_MAPPING.TopChartsPCConsoleGamesDataBrainCalibration,
  },
  // TopCharts_Companies页签的tab的newMarkId映射表
  TopChartsCompanies: {
    Revenue: TABS_NEW_MARKS_MAPPING.TopChartsCompaniesRevenue,
    Downloads: TABS_NEW_MARKS_MAPPING.TopChartsCompaniesDownloads,
    Mentions: TABS_NEW_MARKS_MAPPING.TopChartsCompaniesMentions,
  },
  // StoreRanks_MobileGlobal/Region页签的tab的newMarkId映射表
  'StoreRanksMobileGlobal/Region': {
    alltopcharts: TABS_NEW_MARKS_MAPPING['StoreRanksMobileGlobal/RegionAllTopCharts'],
    globalcompare: TABS_NEW_MARKS_MAPPING['StoreRanksMobileGlobal/RegionGlobalCompare'],
  },
  // StoreRanks_PCGlobal页签的tab的newMarkId映射表
  StoreRanksPCGlobal: {
    steam: TABS_NEW_MARKS_MAPPING.StoreRanksPCGlobalSteam,
    epic: TABS_NEW_MARKS_MAPPING.StoreRanksPCGlobalEpicGames,
  },
  // StoreRanks_ConsoleRegion页签的tab的newMarkId映射表
  StoreRanksConsoleRegion: {
    playstation: TABS_NEW_MARKS_MAPPING.StoreRanksConsoleRegionPlaystation,
    xbox: TABS_NEW_MARKS_MAPPING.StoreRanksConsoleRegionXbox,
    nintendo: TABS_NEW_MARKS_MAPPING.StoreRanksConsoleRegionNintendo,
  },
  // MarketProfile页签的tab的newMarkId映射表
  MarketProfile: {
    MobileGames: TABS_NEW_MARKS_MAPPING.MarketProfileMobileGames,
    PCConsoleGames: TABS_NEW_MARKS_MAPPING.MarketProfilePCConsoleGames,
    PCGames: TABS_NEW_MARKS_MAPPING.MarketProfilePCGames,
    ConsoleGames: TABS_NEW_MARKS_MAPPING.MarketProfileConsoleGames,
    AnnualReport: TABS_NEW_MARKS_MAPPING.MarketProfileAnnualReport,
  },
  // GenreProfile页签的tab的newMarkId映射表
  GenreProfile: {
    mobileGames: TABS_NEW_MARKS_MAPPING.GenreProfileMobileGames,
    pcGames: TABS_NEW_MARKS_MAPPING.GenreProfilePCGames,
    consoleGames: TABS_NEW_MARKS_MAPPING.GenreProfileConsoleGames,
    totalGames: TABS_NEW_MARKS_MAPPING.GenreProfileTotalGames,
  },
  // GlobalView_MarketSize页签的tab的newMarkId映射表
  GlobalViewMarketSize: {
    revenue: TABS_NEW_MARKS_MAPPING.GlobalViewMarketSizeByRevenue,
    players: TABS_NEW_MARKS_MAPPING.GlobalViewMarketSizeByPlayers,
  },
  // GlobalView_TopGenrePerMarket页签的tab的newMarkId映射表
  GlobalViewTopGenrePerMarket: {
    TotalMarket: TABS_NEW_MARKS_MAPPING.GlobalViewTopGenrePerMarketTotalMarket,
    MobileGames: TABS_NEW_MARKS_MAPPING.GlobalViewTopGenrePerMarketMobileGames,
    PCGames: TABS_NEW_MARKS_MAPPING.GlobalViewTopGenrePerMarketPCGames,
    ConsoleGames: TABS_NEW_MARKS_MAPPING.GlobalViewTopGenrePerMarketConsoleGames,
  },
  // GlobalView_TopMarketPerGenre页签的tab的newMarkId映射表
  GlobalViewTopMarketPerGenre: {
    TotalMarket: TABS_NEW_MARKS_MAPPING.GlobalViewTopMarketPerGenreTotalMarket,
    MobileGames: TABS_NEW_MARKS_MAPPING.GlobalViewTopMarketPerGenreMobileGames,
    PCGames: TABS_NEW_MARKS_MAPPING.GlobalViewTopMarketPerGenrePCGames,
    ConsoleGames: TABS_NEW_MARKS_MAPPING.GlobalViewTopMarketPerGenreConsoleGames,
  },
  // Reports_MarketReports页签的tab的newMarkId映射表
  ReportsMarketReports: {
    Newzoo: TABS_NEW_MARKS_MAPPING.ReportsMarketReportsNewzoo,
    'Sensor Tower': TABS_NEW_MARKS_MAPPING.ReportsMarketReportsSensorTower,
    'data.ai': TABS_NEW_MARKS_MAPPING.ReportsMarketReportsDataAi,
    'Stream Hatchet': TABS_NEW_MARKS_MAPPING.ReportsMarketReportsStreamHatchet,
    NPD: TABS_NEW_MARKS_MAPPING.ReportsMarketReportsNPD,
    Statista: TABS_NEW_MARKS_MAPPING.ReportsMarketReportsStatista,
    Famitsu: TABS_NEW_MARKS_MAPPING.ReportsMarketReportsFamitsu,
    Twitter: TABS_NEW_MARKS_MAPPING.ReportsMarketReportsTwitter,
    Fandom: TABS_NEW_MARKS_MAPPING.ReportsMarketReportsFandom,
  },
  // Reports_InsightsReports页签的tab的newMarkId映射表
  ReportsInsightsReports: {
    all: TABS_NEW_MARKS_MAPPING.ReportsInsightsReportsAll,
    'General Gaming': TABS_NEW_MARKS_MAPPING.ReportsInsightsReportsGeneralGaming,
    Esports: TABS_NEW_MARKS_MAPPING.ReportsInsightsReportsEsports,
  },
  // Reports_InsightsReports页签的tab的newMarkId映射表
  ReportsInsightsCenterLibrary: {
    all: TABS_NEW_MARKS_MAPPING.ReportsInsightsCenterLibraryAll,
    'Fundamental Study': TABS_NEW_MARKS_MAPPING.ReportsInsightsCenterLibraryFundamentalStudy,
    GRIP: TABS_NEW_MARKS_MAPPING.ReportsInsightsCenterLibraryGRIP,
    // 'Ad-Hoc Research': TABS_NEW_MARKS_MAPPING.ReportsInsightsCenterLibraryAdHocResearch,
    'Regional Monthly Report': TABS_NEW_MARKS_MAPPING.ReportsInsightsCenterLibraryRegionalMonthlyReport,
  },
  // Reports_IMurReports页签的tab的newMarkId映射表
  ReportsIMurReports: {
    all: TABS_NEW_MARKS_MAPPING.ReportsIMurReportsAll,
    whitePapers: TABS_NEW_MARKS_MAPPING.ReportsIMurReportsWhitePapers,
    monitoring: TABS_NEW_MARKS_MAPPING.ReportsIMurReportsMonitoringReports,
    genres: TABS_NEW_MARKS_MAPPING['ReportsIMurReportsGenres&Competitors'],
    operation: TABS_NEW_MARKS_MAPPING['ReportsIMurReportsOperation&Publishing'],
    specific: TABS_NEW_MARKS_MAPPING.ReportsIMurReportsSpecificReports,
    game: TABS_NEW_MARKS_MAPPING.ReportsIMurReportsGameCompanies,
    tech: TABS_NEW_MARKS_MAPPING.ReportsIMurReportsNewTech,
  },
  // Compare_MobileGames页签的tab的newMarkId映射表
  CompareMobileGames: {
    dau: TABS_NEW_MARKS_MAPPING.CompareMobileGamesActiveUsers,
    revenue: TABS_NEW_MARKS_MAPPING.CompareMobileGamesRevenue,
    download: TABS_NEW_MARKS_MAPPING.CompareMobileGamesDownloads,
    storeRank: TABS_NEW_MARKS_MAPPING.CompareMobileGamesStoreRank,
  },
  // Compare_PCConsoleGames页签的tab的newMarkId映射表
  ComparePCConsoleGames: {
    pcu: TABS_NEW_MARKS_MAPPING.ComparePCConsoleGamesPCU,
    mau: TABS_NEW_MARKS_MAPPING.ComparePCConsoleGamesMAU,
    digitalRevenue: TABS_NEW_MARKS_MAPPING.ComparePCConsoleGamesDigitalRevenue,
    physicalRevenue: TABS_NEW_MARKS_MAPPING.ComparePCConsoleGamesPhysicalRevenue,
  },
  // Potential_NewReleaseGames页签的tab的newMarkId映射表
  PotentialNewReleaseGames: {
    MobileGames: TABS_NEW_MARKS_MAPPING.PotentialNewReleaseGamesMobileGames,
    PCGames: TABS_NEW_MARKS_MAPPING.PotentialNewReleaseGamesPCGames,
    ConsoleGames: TABS_NEW_MARKS_MAPPING.PotentialNewReleaseGamesConsoleGames,
  },
  // Potential_UpcomingGames页签的tab的newMarkId映射表
  PotentialUpcomingGames: {
    MobileGames: TABS_NEW_MARKS_MAPPING.PotentialUpcomingGamesMobileGames,
    PCGames: TABS_NEW_MARKS_MAPPING.PotentialUpcomingGamesPCGames,
    ConsoleGames: TABS_NEW_MARKS_MAPPING.PotentialUpcomingGamesConsoleGames,
  },
  // Source&Metrics_Sources页签的tab的newMarkId映射表
  'Sources&MetricsSources': {
    IntelligenceSources: TABS_NEW_MARKS_MAPPING['Sources&MetricsSourcesIntelligenceSources'],
    OpinionsSources: TABS_NEW_MARKS_MAPPING['Sources&MetricsSourcesOpinionsSources'],
    NewsCrawlers: TABS_NEW_MARKS_MAPPING['Sources&MetricsSourcesNewsCrawlers'],
  },
  // Source&Metrics_Metrics页签的tab的newMarkId映射表
  'Sources&MetricsMetrics': {
    IntelligenceMetrics: TABS_NEW_MARKS_MAPPING['Sources&MetricsMetricsIntelligenceMetrics'],
    OpinionsMetrics: TABS_NEW_MARKS_MAPPING['Sources&MetricsMetricsOpinionsMetrics'],
    MobileGameFields: TABS_NEW_MARKS_MAPPING['Sources&MetricsMetricsMobileGameFields'],
    PCConsoleFields: TABS_NEW_MARKS_MAPPING['Sources&MetricsMetricsPCConsoleGameFields'],
    CompanyFields: TABS_NEW_MARKS_MAPPING['Sources&MetricsMetricsCompanyFields'],
    DeviceMetrics: TABS_NEW_MARKS_MAPPING['Sources&MetricsMetricsDeviceMetrics'],
  },
  // MobileGamesDetails页签的tab的newMarkId映射表
  MobileGamesDetails: {
    overview: TABS_NEW_MARKS_MAPPING.MobileGamesDetailsOverview,
    stats: TABS_NEW_MARKS_MAPPING.MobileGamesDetailsStats,
    countries: TABS_NEW_MARKS_MAPPING.MobileGamesDetailsCountries,
    storeRank: TABS_NEW_MARKS_MAPPING.MobileGamesDetailsStoreRank,
    streaming: TABS_NEW_MARKS_MAPPING.MobileGamesDetailsStreaming,
    demographics: TABS_NEW_MARKS_MAPPING.MobileGamesDetailsDemographics,
    overlap: TABS_NEW_MARKS_MAPPING.MobileGamesDetailsOverlap,
    opinions: TABS_NEW_MARKS_MAPPING.MobileGamesDetailsOpinions,
    gameComparison: TABS_NEW_MARKS_MAPPING.MobileGamesDetailsGameComparison,
  },
  // PCGamesDetails页签的tab的newMarkId映射表
  PCGamesDetails: {
    overview: TABS_NEW_MARKS_MAPPING.PCGamesDetailsOverview,
    stats: TABS_NEW_MARKS_MAPPING.PCGamesDetailsStats,
    countries: TABS_NEW_MARKS_MAPPING.PCGamesDetailsCountries,
    storeRank: TABS_NEW_MARKS_MAPPING.PCGamesDetailsStoreRank,
    streaming: TABS_NEW_MARKS_MAPPING.PCGamesDetailsStreaming,
    opinions: TABS_NEW_MARKS_MAPPING.PCGamesDetailsOpinions,
    overlap: TABS_NEW_MARKS_MAPPING.PCGamesDetailsOverlap,
    gameComparison: TABS_NEW_MARKS_MAPPING.PCGamesDetailsGameComparison,
  },
  // ConsoleGamesDetails页签的tab的newMarkId映射表
  ConsoleGamesDetails: {
    overview: TABS_NEW_MARKS_MAPPING.ConsoleGamesDetailsOverview,
    stats: TABS_NEW_MARKS_MAPPING.ConsoleGamesDetailsStats,
    countries: TABS_NEW_MARKS_MAPPING.ConsoleGamesDetailsCountries,
    storeRank: TABS_NEW_MARKS_MAPPING.ConsoleGamesDetailsStoreRank,
    streaming: TABS_NEW_MARKS_MAPPING.ConsoleGamesDetailsStreaming,
    opinions: TABS_NEW_MARKS_MAPPING.ConsoleGamesDetailsOpinions,
    gameComparison: TABS_NEW_MARKS_MAPPING.ConsoleGamesDetailsGameComparison,
  },
  // PCConsoleGamesDetails页签的tab的newMarkId映射表
  PCConsoleGamesDetails: {
    overview: TABS_NEW_MARKS_MAPPING.PCConsoleGamesDetailsOverview,
    originalStats: TABS_NEW_MARKS_MAPPING.PCConsoleGamesDetailsStats,
    countries: TABS_NEW_MARKS_MAPPING.PCConsoleGamesDetailsCountries,
    storeRank: TABS_NEW_MARKS_MAPPING.PCConsoleGamesDetailsStoreRank,
    streaming: TABS_NEW_MARKS_MAPPING.PCConsoleGamesDetailsStreaming,
    opinions: TABS_NEW_MARKS_MAPPING.PCConsoleGamesDetailsOpinions,

    overlap: TABS_NEW_MARKS_MAPPING.PCConsoleGamesDetailsOverlap,
    gameInfo: TABS_NEW_MARKS_MAPPING.PCConsoleGamesDetailsGameInfo,
    stats: TABS_NEW_MARKS_MAPPING.PCConsoleGamesDetailsKPITrends,
    gameComparison: TABS_NEW_MARKS_MAPPING.PCConsoleGamesDetailsGameComparison,
  },
  // CompaniesDetails页签的tab的newMarkId映射表
  CompaniesDetails: {
    Summary: TABS_NEW_MARKS_MAPPING.CompaniesDetailsSummary,
    NewsActivity: TABS_NEW_MARKS_MAPPING['CompaniesDetailsNews&Activity'],
    GamesStats: TABS_NEW_MARKS_MAPPING['CompaniesDetailsGames&Stats'],
    Financials: TABS_NEW_MARKS_MAPPING.CompaniesDetailsFinancials,
    SubsidiaryCompanies: TABS_NEW_MARKS_MAPPING.CompaniesDetailsSubsidiaryCompanies,
    People: TABS_NEW_MARKS_MAPPING.CompaniesDetailsPeople,
    SimilarCompanies: TABS_NEW_MARKS_MAPPING.CompaniesDetailsSimilarCompanies,
  },
  // MarketProfileDetails页签的tab的newMarkId映射表
  MarketProfileDetails: {
    Overview: TABS_NEW_MARKS_MAPPING.MarketProfileDetailsOverview,
    Insights: TABS_NEW_MARKS_MAPPING.MarketProfileDetailsInsights,
    Stats: TABS_NEW_MARKS_MAPPING.MarketProfileDetailsStats,
    Demographics: TABS_NEW_MARKS_MAPPING.MarketProfileDetailsDemographics,
  },
  // GenreProfileDetails页签的tab的newMarkId映射表
  GenreProfileDetails: {
    insights: TABS_NEW_MARKS_MAPPING.GenreProfileDetailsInsights,
    stats: TABS_NEW_MARKS_MAPPING.GenreProfileDetailsStats,
  },
  IPLibrary: {
    '1cb3269e-13c5-4e1b-9419-a6f8dd60f4a5': TABS_NEW_MARKS_MAPPING.IPLibraryGameIPClassicalIP,
  },
};

// 左侧菜单底部按钮标记小红点
export const MENUS_FOOTER_RED_MARK_MAPPING: { [key: string]: string } = {
  /** 指标置信度 */
  MetricsCreditability: 'point00001',
  /** 数据隐私 */
  DataPrivacy: 'point00002',
};

/** 2025-3-20，接口更新数据，之后添加或替换都参照以下数据参数
{
  new_mark_id: 'menu00162',
  new_mark_name: 'OverlapAnalysisSteamGames',
  mark_type: 0,
},
{
  new_mark_id: 'menu00028',
  new_mark_name: 'IPLibrary',
  mark_type: 0,
},
{
  new_mark_id: 'tab00527',
  new_mark_name: 'PCConsoleGamesDetailsOverlap',
  mark_type: 0,
},
{
  new_mark_id: 'tab00521',
  new_mark_name: 'PCConsoleGamesDetailsOverview',
  mark_type: 0,
},
{
  new_mark_id: 'tab00528',
  new_mark_name: 'PCConsoleGamesDetailsGameInfo',
  mark_type: 0,
},
{
  new_mark_id: 'tab00529',
  new_mark_name: 'PCConsoleGamesDetailsKPITrends',
  mark_type: 0,
},
{
  new_mark_id: 'tab00530',
  new_mark_name: 'PCConsoleGamesDetailsCountries',
  mark_type: 1,
},
{
  new_mark_id: 'point00002',
  new_mark_name: 'DataPrivacy',
  mark_type: 0,
},
******/
